import { CreateSlice } from './index'

export type TableSettingsSchema = {
    [key: string]: {
        [variable: string]: string | number | symbol | undefined
    }
}

export interface TableSettingsState {
    tables: TableSettingsSchema
    setTableVariable: <
        T extends keyof TableSettingsSchema,
        K extends keyof TableSettingsSchema[T],
    >(
        tableName: T,
        variable: K,
        value: TableSettingsSchema[T][K],
    ) => void
}

export const createTableSettingsSlice: CreateSlice<
    TableSettingsState
> = set => ({
    tables: {},
    setTableVariable: (tableName, variable, value) => {
        set(state => ({
            tables: {
                ...state.tables,
                [tableName]: {
                    ...state.tables[tableName],
                    [variable]: value,
                },
            },
        }))
    },
})
